import React from 'react';

export default function MailboxReviewForm({
  review,
  setReview,
  disabled,
  onSubmit,
  onCancel,
  originalSend = false,
}) {
  const messagePattern = originalSend
    ? '[A-Za-z0-9._:\\-]{6,200}'
    : '(?:[A-Za-z0-9._:@\\-]{6,200}|<[A-Za-z0-9._:@\\-]{4,198}>)';
  const valid =
    review.confirmedMailbox === true &&
    review.reason.trim().length >= 12 &&
    review.reason.length <= 300 &&
    ['sent', 'not_sent'].includes(review.outcome) &&
    (review.outcome !== 'sent' || new RegExp(`^(?:${messagePattern})$`).test(review.messageId));
  return (
    <form onSubmit={onSubmit} className="me-distributor-admin-review grid gap-3 sm:grid-cols-2">
      <label>
        Verified outcome
        <select
          disabled={disabled}
          className="block rounded border p-2"
          value={review.outcome}
          onChange={(event) =>
            setReview((current) => ({
              ...current,
              outcome: event.target.value,
              confirmedMailbox: false,
            }))
          }
        >
          <option value="sent">Found sent message</option>
          <option value="not_sent">Confirmed not sent</option>
        </select>
      </label>
      {review.outcome === 'sent' && (
        <label>
          {originalSend ? 'Original send reference' : 'Mailbox message ID'}
          <input
            disabled={disabled}
            minLength={6}
            maxLength={200}
            pattern={messagePattern}
            required
            className="block rounded border p-2"
            value={review.messageId}
            onChange={(event) =>
              setReview((current) => ({
                ...current,
                messageId: event.target.value,
                confirmedMailbox: false,
              }))
            }
          />
        </label>
      )}
      <p className="text-sm text-slate-600 sm:col-span-2">
        {originalSend
          ? 'Independently verify this order and attempt in Sent Items before copying a recorded reference. A Microsoft request reference alone does not prove an email was sent. If you cannot match the original attempt, contact MedEffects support.'
          : 'Copy the message ID from the verified sent message details. This records your mailbox review; it does not independently verify delivery.'}
      </p>
      <label>
        Review reason (no patient details)
        <input
          disabled={disabled}
          className="block rounded border p-2"
          minLength={12}
          maxLength={300}
          required
          value={review.reason}
          onChange={(event) =>
            setReview((current) => ({
              ...current,
              reason: event.target.value,
              confirmedMailbox: false,
            }))
          }
        />
      </label>
      <label className="me-distributor-admin-confirm flex items-start gap-2">
        <input
          disabled={disabled}
          type="checkbox"
          checked={review.confirmedMailbox}
          onChange={(event) =>
            setReview((current) => ({ ...current, confirmedMailbox: event.target.checked }))
          }
        />
        I checked the sending mailbox for this attempt
      </label>
      <div className="flex flex-wrap gap-3 sm:col-span-2">
        <button
          type="submit"
          disabled={disabled || !valid}
          className="me-distributor-admin-primary"
        >
          Save mailbox review
        </button>
        <button
          type="button"
          disabled={disabled}
          onClick={onCancel}
          className="me-distributor-admin-secondary"
        >
          Cancel review
        </button>
      </div>
    </form>
  );
}
